<template>
  <div class="common-page driver-workforce-management">
    <div class="top-box">
      <div class="tab-box">
        <custom-tab-box :tabData="tabData" :selectTab="selectTab" @change="handleChangeTab"></custom-tab-box>
      </div>
    </div>
    <div class="components-content">
      <driver-scheduling v-if="selectTab === 1"></driver-scheduling>
      <calendar-scheduling v-if="selectTab === 2"></calendar-scheduling>
    </div>
  </div>
</template>

<script>
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CalendarScheduling from "./components/calendarScheduling.vue";
import DriverScheduling from "./components/driverScheduling.vue";
export default {
  name: "Staff-management",
  components: {
    CalendarScheduling,
    DriverScheduling,
    CustomTabBox,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "司机排班",
        },
        {
          label: 2,
          value: "日历排班",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    handleChangeTab(val) {
      this.selectTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.driver-workforce-management {
  display: flex;
  flex-direction: column;
  .top-box {
    flex-shrink: 0;
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .components-content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }

}
</style>
